var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shiftChartVisible
    ? _c("div", {
        staticClass: "shift-production-container",
        attrs: { id: "shift-production-container" }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }